import { useEffect, useState } from "react";

import { Table } from "../../../../../../Components/FinalTable";

import THeader from "./THeader";

import TBody from "./TBody";

import TInfo from "./TInfo";

import TContext from "./TContext";

import { TableTopBar } from "../../../../../../Components/FinalTable";

import BtnRounded from "../../../../../../Components/Buttons/BtnRounded";

import { useNavigate, useParams } from "react-router-dom";

import useApp from "../../../../../../Hooks/useApp";

import useAxios from "../../../../../../Hooks/useAxios";

import usePouchCud from "./../../../../Hooks/usePouchCud";

import Fuse from "fuse.js";

const AllSpacesTable = () => {
  const [total, setTotal] = useState(0);

  const [limit, setLimit] = useState(5);

  const [data, setData] = useState([]);

  const [checked_id, setCheckedId] = useState(-1);

  const [showPagination, setShowPagination] = useState(true);

  const { id } = useParams();


  const [page, setPage] = useState(1);

  const [hasNextPage, setHasNextPage] = useState(false);

  const [hasPrevPage, setHasPrevPage] = useState(false);



  const [tableIsLoading, setTableIsLoading] = useState(false);

  const [isFiltered, setIsFiltered] = useState(false);

  const [searchInput, setSearchInput] = useState("");

  const [fixed, setFixed] = useState({});

  const { create } = usePouchCud();


  const request = useAxios();

  const { setShowFormModal, setModalMessage, setShowSuccessModal } = useApp();

  const [docs, setDocs] = useState(0);

  const navigate = useNavigate();


  const getSpaces = async(
    page = 1
    )=>{
    setTableIsLoading(true);
    let res = await request({
      method: "GET",
      url: "hospital/spaces",
      params: {
        page,
        limit,
      },
      network_error: false,
    });

    if (res === "network-error") {
      navigate("/dashboard/team");
      return;
    }

    setTableIsLoading(false);

    if (res === "error") {
      navigate("/dashboard/team");
      return;
    }

    setData(res.docs);
    setHasNextPage(res.hasNextPage);
    setHasPrevPage(res.hasPrevPage);
    setTotal(res.total_docs);
  }

  useEffect(()=>{
    getSpaces(1)
  },[limit])

  useEffect(() => {
    if (searchInput.length < 3) return;
    async function search() {
      setTableIsLoading(true);
      let res = await request({
        method: "GET",
        url: "hospital/spaces/search",
        params: {
          value: searchInput,
        },
      });

      if (res === "network-error") {
        navigate("/dashboard/team");
        return;
      }

      if (res === "error") return;

      const fuse = new Fuse(
        [...res],
        {
          keys: ["name", "code", "shelf_no"],
        }
      );

      const result = fuse.search(searchInput);

      let ids = [];
      let new_docs = [];

      for (let i = 0; i < result.length; i++) {
        if (i === limit) {
          break;
        }
        let doc = result[i].item;
        if (ids.includes(doc.id)) {
          continue;
        }
        ids.push(doc.id);
        new_docs.push(doc);
      }
      setData(new_docs);

      setShowPagination(false);
      setIsFiltered(true);
      setTableIsLoading(false);
    }

    search();
  }, [searchInput]);

  async function handleClearFilters() {
    await getSpaces(1, "created_at", "desc");
    setPage(1);
    setSearchInput("");
    setIsFiltered(false);
    setShowPagination(true);
  }

  async function Submit() {
    if (docs.length === 0) {
      setModalMessage("Select at least one Space");
      setShowFormModal(true);
      return;
    }
    let res = await request({
      method: "POST",
      url: "hospital/space/assign",
      data: {
        user_id: parseInt(id),
        space_id: parseInt(checked_id),
      },
    });

    if (res !== "error") {
      setModalMessage("Space Added");
      setShowSuccessModal(true);
      await create({ name: "space_team", doc: res });
      navigate(`/dashboard/team/view/${id}`);
    }
  }

  async function handleNext() {
    if (hasNextPage) {
      setPage(page + 1);
      getSpaces(page + 1);
    }
  }

  async function handlePrev() {
    if (hasPrevPage) {
      setPage(page - 1);
      getSpaces(page - 1);
    }
  }

  return (
    <TContext.Provider
      value={{
        limit,
        setLimit,
        data,
        page,
        hasNextPage,
        hasPrevPage,
        handleNext,
        handlePrev,
        isFiltered,
        handleClearFilters,
        total,
        setIsFiltered,
        showPagination,
        setFixed,
        checked_id,
        setCheckedId,
        docs,
        setDocs,
      }}
    >
      <div className="w-full min-h-screen bg-white px-7 pb-8">
        <TableTopBar
          mt={2}
          mb={2}
          showAdd={false}
          // AddClick={handleAdd}

          isFiltered={isFiltered}
          handleClearFilters={handleClearFilters}
          tableIsLoading={tableIsLoading}
          showReport={false}
          showFilter={false}
          // addLabel="Add"
          searchInput={searchInput}
          setSearchInput={setSearchInput}
        />
        <Table>
          <THeader />
          <TBody />
          <TInfo />
          <div className="max-w-2xl w-full mx-auto">
            <BtnRounded mt={2} click={Submit} className="btn">
              <span className=" font-pop-reg">Add Space</span>
              <span className="px-3 font-normal text-2xl"></span>
            </BtnRounded>
          </div>
        </Table>
      </div>
    </TContext.Provider>
  );
};

export default AllSpacesTable;
